import { render, staticRenderFns } from "./VerticalTable.vue?vue&type=template&id=95ff8146"
import script from "./VerticalTable.vue?vue&type=script&lang=js"
export * from "./VerticalTable.vue?vue&type=script&lang=js"
import style0 from "@/assets/VerticalTable.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports